import { num, plural } from "./format";

/**
 * El cartel de arriba de «Resultados» después de lanzar: qué pasó con el envío, según el estado REAL de la
 * campaña y no según la respuesta del momento en que se apretó el botón.
 *
 * QA del 08/10: decía «114 mensajes en la fila de envío · Enviando en segundo plano, de a poco» para siempre,
 * aunque la tabla de abajo ya mostrara los 114 enviados. Era la respuesta de `send()` congelada: el asistente
 * seguía la campaña hasta que terminaba, pero sólo para traer la tabla, y el cartel nunca se enteraba.
 *
 * @param envio lo que devolvió `send()` (cuántos se encolaron, el mensaje del backend, los mails frenados)
 * @param estado el estado de la campaña ahora («enviando» mientras el worker despacha)
 * @param pendientes `stats.pendientes` de la campaña: lo que quedó sin salir (cupo diario, fuera de horario)
 */
export function resumenDelEnvio(
  envio: { encolados?: number; mensaje?: string; emailsSinLinkBaja?: number; motivoEmail?: string },
  estado: string | undefined,
  pendientes = 0,
): { titulo: string; detalle: string; enCurso: boolean; tono: "curso" | "ok" | "aviso" } {
  const encolados = Number(envio.encolados) || 0;
  if (!estado || estado === "enviando") {
    return {
      titulo: `${num(encolados)} ${plural(encolados, "mensaje", "mensajes")} en la fila de envío`,
      detalle: envio.mensaje || "",
      enCurso: true,
      tono: "curso",
    };
  }
  const mails = Number(envio.emailsSinLinkBaja) || 0;
  const avisoMails = mails > 0
    ? `${num(mails)} ${plural(mails, "mail no salió", "mails no salieron")}. ${envio.motivoEmail || ""}`.trim()
    : "";
  if (estado === "sent" || estado === "measured") {
    const pend = Number(pendientes) || 0;
    if (pend > 0) {
      return {
        titulo: `Terminó esta tanda: ${num(pend)} ${plural(pend, "mensaje quedó", "mensajes quedaron")} sin salir`,
        detalle: [
          "Se cortó por el cupo diario de las líneas o por el horario de envío, y no sigue sola: reanudala desde el detalle de la campaña.",
          avisoMails,
        ].filter(Boolean).join(" "),
        enCurso: false,
        tono: "aviso",
      };
    }
    return { titulo: "Terminó el envío", detalle: avisoMails, enCurso: false, tono: avisoMails ? "aviso" : "ok" };
  }
  // volvió a «lista para enviar» sin que saliera ninguno (todo fuera de horario, sin cupo, sin líneas…)
  return {
    titulo: "No salió ningún mensaje",
    detalle: ["En el detalle de la campaña está el motivo y el botón para reanudar el envío.", avisoMails].filter(Boolean).join(" "),
    enCurso: false,
    tono: "aviso",
  };
}
